// @Version: 1.1.0
import {Component, EventEmitter, OnDestroy, Output} from "@angular/core";
import {UntilDestroy} from "@ngneat/until-destroy";
import { TRANSLATE_PATH } from "src/app/shared/shared.model";

@UntilDestroy()
@Component({
   selector: "app-header-no-login",
   templateUrl: "./header-no-login.component.html",
   standalone: false
})
export class HeaderNoLoginComponent implements OnDestroy {

   public TRANSLATE_PATH: typeof TRANSLATE_PATH = TRANSLATE_PATH;
   @Output() public sidenavToggle: EventEmitter<void> = new EventEmitter();

   ngOnDestroy(): void {}


   public onToggleSidenav = () => {
      this.sidenavToggle.emit();
   };
}